import { FormEntry } from "components";
import { Fragment, useEffect, useState } from "react";
import { useFieldArray, useWatch } from "react-hook-form";
import { FiX } from "react-icons/fi";
import { Button } from "reactstrap";

export const ThirdPage = ({ register, errors, studentPrefix, setStudentPrefix, watch, control }) => {
	const {
		fields: learningObjectives,
		append,
		remove: removeCustomLO,
	} = useFieldArray({
		control,
		name: `studentReport.${studentPrefix}.learningObjectives`,
	});

	useEffect(() => {
		setStudentPrefix(studentPrefix);
	}, []);

	const appendCustomLO = () => {
		append({
			performance: undefined,
			name: undefined,
			custom: true,
		});
	};

	return (
		<>
			{learningObjectives.map((learningObj, index) => (
				<Fragment key={learningObj.id}>
					{learningObj.custom && (
						<div className="d-flex justify-content-end align-items-center mb-1 text-danger">
							<span
								className="btn btn-link btn-danger py-1 border-danger border"
								onClick={() => removeCustomLO(index)}
								style={{ cursor: "pointer" }}
							>
								<FiX className="mr-1" size={20} />
								Remove
							</span>
						</div>
					)}
					<FormEntry
						register={register}
						labelEditable={learningObj.custom}
						labelInputName={`learningObjectives.${index}.name`}
						labelPlaceholder="Insert LO Name"
						labelInputRequired={true}
						labelInputError={errors.studentReport?.[studentPrefix]?.learningObjectives?.[index]?.name}
						labelInputTitle="Custom LO Name"
						prefix={"studentReport." + studentPrefix}
						placeholder="Score (0-5)"
						key={learningObj.id}
						formLabel={learningObj.name}
						type="number"
						name={`learningObjectives.${index}.performance`}
						required={true}
						validation={{
							validate: {
								checkMorethan0Lessthan5: (value) =>
									(!isNaN(value) && value <= 5 && value >= 0) || "Value must be more than 0 or less than 5",
							},
						}}
						error={errors.studentReport?.[studentPrefix]?.learningObjectives?.[index]?.performance}
					/>
				</Fragment>
			))}
			<div className="d-flex justify-content-end mb-4">
				<Button
					color="info"
					size="sm"
					onClick={() =>
						appendCustomLO({
							performance: undefined,
							name: undefined,
							custom: true,
						})
					}
				>
					Add custom LO
				</Button>
			</div>
		</>
	);
};
